<!--
 * @Description: 添加字段，搜索字段
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="select-list-com">
    <div class="search-field-wrapper">
      <jw-input-search :style="{ width: '320px' }" :placeholder="$t('请输入搜索内容')" v-model="searchFieldName" allow-clear @input="searchCk" />
      <jw-checkbox value="1" :model-value="checkedAll" :indeterminate="indeterminate" @change="handleChangeAll">{{ $t('全选') }}</jw-checkbox>
    </div>
    <div class="search-field-content">
      <template v-if="getlistData?.length > 0">
        <template v-for="(item, index) in getlistData" :key="index">
          <fh-divider v-if="item?.isFirstTypeOne"></fh-divider>
          <div class="field-list">
            <!-- 2025年07月15日14:34:32置灰逻辑调整，当前字段置灰或者当前不能为空且被选中且不为子表单字段且只有一个非子表单字段被选中 -->
            <jw-checkbox v-model="item.showField" :value="item.settingId" :disabled="item.fieldKey == batchTableKey || item.disabled || (isDisabledChecked && item.showField && !item?.entityType)" @change="handleChange"></jw-checkbox>

            <div class="search-field-content-right">
              <template v-if="isonIsShow">
                <component :is="componentFun(item)" />
              </template>
              <template v-if="getMatchIndex(item?.label) < 0">
                <div class="field-name">{{ item.label }}</div>
              </template>
              <template v-else>
                <div class="field-name">
                  {{ item?.label?.substr(0, getMatchIndex(item?.label)) }}
                  <span class="high-light">{{ item?.label?.substr(getMatchIndex(item?.label), searchFieldName.length) }}</span
                  >{{ item?.label?.substr(getMatchIndex(item?.label) + searchFieldName.length) }}
                </div>
              </template>
            </div>
          </div>
        </template>
      </template>
      <!-- 可以为空的时候显示空状态 -->
      <template v-else>
        <jw-empty></jw-empty>
      </template>
    </div>
  </div>
</template>
<script setup>
import { reactive, watchEffect, computed, ref } from 'vue';
const emits = defineEmits(['cb']);
import useFields from '@/hooks/fields';
import fhDivider from '@/components/fh-divider/fh-divider.vue';
const { fieldIconMapping, moveTypeOneToEnd } = useFields();
const props = defineProps({
  list: {
    // 字段信息
    type: Object,
    default: () => {}
  },
  checkIds: {
    // 被选中的字段信息
    type: Array,
    default: () => []
  },
  empty: {
    // 列表是否可以为空
    type: Boolean,
    default: false
  },
  isonIsShow: {
    // 是否可显示图标
    type: Boolean,
    default: false
  },
  batchTableKey: {
    type: String,
    default: ''
  }
});

const searchFieldName = ref('');
const isDisabledChecked = computed(() => {
  return !props.empty && data.listModules?.filter((gd) => gd?.showField && !gd?.entityType)?.length == 1;
});
const componentFun = (ele) => {
  //字段图表
  return fieldIconMapping.value[Number(ele.fieldType)];
};
const data = reactive({
  listData: {}, //110的所有数据
  listModules: [] //字段信息
});
const checkedAll = ref(false);
const getMatchIndex = (title) => {
  //搜索结果红色提醒
  if (!searchFieldName.value) return -1;
  return title.toLowerCase().indexOf(searchFieldName.value.toLowerCase());
};
// 封装更新 showField 的逻辑
const updateShowField = (element, checkIds) => {
  element.showField = checkIds.includes(element.settingId);
};

// 封装设置 label 的逻辑
const setLabel = (element, prefix = '') => {
  element.label = prefix ? `${prefix.fieldName}.${element.fieldName}` : element.fieldName || element.name || element.label;
  element.entityType = prefix ? prefix?.fieldExt : ''; //子表单的 entity
};
// 全部字段
const getlistData = computed(() => {
  const getResultData = [];
  data.listModules.map((afl) => {
    if (searchFieldName.value === '' || afl?.label?.indexOf(searchFieldName.value) > -1) {
      getResultData.push(afl);
    }
  });
  return moveTypeOneToEnd(getResultData);
});
// 处理 props.list
const processlist = () => {
  if (!Array.isArray(props?.list)) {
    return;
  }

  props.list.forEach((item) => {
    if (item.fieldType == 27) {
      const subModules = item?.settings || item?.modules;
      if (Array.isArray(subModules)) {
        subModules.forEach((sub) => {
          setLabel(sub, item);
          updateShowField(sub, props.checkIds);
          data.listModules.push(sub);
        });
      }
    } else {
      setLabel(item);
      updateShowField(item, props.checkIds);
      data.listModules.push(item);
    }
  });
  checkedAll.value = false;
  // if (data.listModules.filter((item) => item.showField)?.length == data.listModules?.length) {
  //   checkedAll.value = true;
  // }
  if (getlistData.value?.filter((item) => item.showField)?.length == getlistData.value?.length) {
    checkedAll.value = true;
  }
};

watchEffect(() => {
  data.listData = props.list;
  data.listModules = [];
  processlist();

  if (!props.empty) {
    //不可为空
    const otherFields = data.listModules?.filter((el) => !el?.showField && !el?.entityType); //除了子表单 ，其他字段剩下一个被选中 需要置灰
    if (otherFields?.length == 1) {
      //若全部都隐藏了，判断最后一个非子字段不能隐藏
      data.listModules.forEach((item) => {
        if (item?.showField) {
          item.disabled = false;
        }
      });
    }
  }
});

//半选状态
const indeterminate = computed(() => {
  return getCheckedAllFields.value?.length > 0 && getlistData.value?.length > 0 && getlistData.value?.length != getCheckedAllFields.value?.length;
});

const getAllIds = computed(() => (Array.isArray(data.listModules) ? data.listModules.map((item) => item.settingId) : [])); //获取所有字段
const getCheckedAllFields = computed(() => (Array.isArray(getlistData.value) ? getlistData.value?.filter((el) => el?.showField) : [])); //被选中的字段

const getCheckedFields = computed(() => (Array.isArray(getlistData.value) ? getlistData.value?.filter((el) => el?.showField && !el?.entityType) : [])); //被选中的非子表的字段
const getUncheckIds = computed(() => (Array.isArray(getlistData.value) ? getlistData.value.filter((el) => !el?.showField && !el?.entityType).map((item) => item.settingId) : [])); //获取非子表的隐藏的字段
const exposeCheckedModules = (oprateListData) => {
  const updatelistModules = Array.isArray(data.listModules) ? data.listModules : []; //抛出数据
  emits('cb', { modules: updatelistModules, oprateList: oprateListData });
};
const searchCk = () => {
  checkedAll.value = false;
  if (getlistData.value?.length == getCheckedAllFields.value?.length) {
    checkedAll.value = true;
  }
};
// 更新被选中的状态
const updateShowFlag = (e) => {
  if (getAllIds.value?.length == getlistData.value?.length) {
    //全选,反选
    data.listModules.forEach((item) => {
      item.showField = e;
      item.disabled = false;
    });
  } else {
    data.listModules.forEach((item) => {
      const findSubfield = getlistData.value?.find((mo) => mo.settingId == item.settingId);
      if (findSubfield) {
        item.showField = e;
      }

      item.disabled = false;
    });
  }
};
// 更新最后一个字段的选中状态禁用
const updateLastfield = () => {
  if (Array.isArray(data.listModules)) {
    for (let i = 0; i < data.listModules.length; i++) {
      //反选后 默认选中主属性字段
      const current = data.listModules[i];
      if (current?.mainField || current.fieldKey == props.batchTableKey) {
        //非子字段
        current['showField'] = true;
        // 非主属性字段 或者 有批量查找关联字段
        current.disabled = !current?.mainField || !props.batchTableKey ? true : false;
        // break;
      }
    }
  }
};
// 单字段选中
const handleChange = (e, ev) => {
  // console.log('eeeeeeeeeeee', ev.target.value);
  const oprateItemData = [];
  data.listModules.forEach((item) => {
    if (ev.target.value == item.settingId) {
      item.showField = e;
      oprateItemData.push(item);
    }

    item.disabled = false;
  });

  if (!props.empty) {
    //不可为空
    if (e && getCheckedFields.value?.length > 1) {
      //被选中了至少一个字段
      if (Array.isArray(data.listModules)) {
        data.listModules.forEach((item) => {
          item.disabled = false;
        });
      }
    }
    const getAllIds = data.listModules?.filter((el) => !el?.entityType); //非子表单
    if (getAllIds?.length == getUncheckIds.value?.length + 1 && !e) {
      //反选
      //若全部都隐藏了，判断最后一个非子字段不能隐藏
      if (Array.isArray(data.listModules)) {
        for (let i = 0; i < data.listModules.length; i++) {
          const item = data.listModules[i];
          if (!item?.entityType && item?.showField) {
            //非子字段
            item.disabled = true;
            break;
          }
        }
      }
    }
  }
  if (getlistData.value?.length == getCheckedAllFields.value?.length) {
    checkedAll.value = true;
  } else {
    checkedAll.value = false;
  }
  exposeCheckedModules(oprateItemData);
};
// 全选
const handleChangeAll = (e) => {
  checkedAll.value = e;
  updateShowFlag(e);
  if (!e) {
    //反选
    if (!props.empty) {
      //不可为空
      const showFields = data.listModules?.filter((el) => !el?.showField);
      const entityTypes = data.listModules?.filter((el) => !el?.entityType);
      const otherFields = data.listModules?.filter((el) => !el?.showField && !el?.entityType);
      if (showFields?.length == data.listModules?.length || entityTypes?.length == otherFields?.length) {
        //若全部都隐藏了，判断最后一个非子字段不能隐藏
        updateLastfield();
      }
    }
  }
  exposeCheckedModules(getlistData.value);
};
</script>

<style scoped lang="less">
@import './select-field.less';
</style>
